import React from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';
import axios from 'axios';
import PropTypes from 'prop-types';
/**
 * Validator
 */
import InputError from './InputError';
import Validator from '../libs/Validator';
import * as MESSAGES from '../libs/Messages';
import Progress from './Progress';


export default class FilesUploaded extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isError: false,
            errorMessage: null,
            errors: {},
        }
    }

    componentDidMount() {

    }

    convertByte = (filesize) => {
        var return_value = '';
        if (filesize < 1000000) {
            return_value = Math.floor(parseInt(filesize) / 1000) + 'KB';
        } else {
            return_value = Math.floor(parseInt(filesize) / 1000000) + 'MB';
        }
        return return_value;
    }

    render() {
        return (
            <div className={`uploading-files input-group shadow mb-3 attachment-file`}>
                <div className={`attachment-filename`}>{this.props.fileInfo.filenameshow}</div>             
                <div className="input-group-append">                   
                    <button className="btn btn-x" type="button" onClick={this.props.onDeleteFile.bind(this, this.props.fileInfo.filename, this.props.fileIndex)}></button>
                </div>
            </div>
        );
    }
}

FilesUploaded.propTypes = {
    onDeleteFile: PropTypes.func,
    onChangeSelfie: PropTypes.func
};